/* eslint-disable */

// shop page
// Show Filter column
//
import $ from "jquery";

const $filtersColumn = $('.filters-column');
const $shopSidebar = $('.shop-sidebar');
const $shopFeature = $('.sidebar-feature');

 export class WC_Shop_Filter_Bottom {

  constructor() {

    // is the Shop element even here?
    if (!$('.shop').length > 0) return;

    $(function () {
      if ($(window).width() < 992) {
        return;
      }

      $.fn.isInViewport = function() {
        const elementTop = $(this).offset().top;
        const elementBottom = elementTop + $(this).outerHeight();

        const viewportTop = $(window).scrollTop();
        const viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
      };

    let position = $(window).scrollTop();

// should start at 0

    $(window).scroll(function() {
      const scroll = $(window).scrollTop();
      if(scroll > position) {
        // if scroll down
        $(window).on('resize scroll', function() {
          if (!$('.shop-title').isInViewport()) {
            // do something
            $shopSidebar.addClass('filter-fixed');
          }
        });
      } else {
        // if scroll up
        $(window).on('resize scroll', function() {
          if ($('.hero').isInViewport()) {

            $shopSidebar.removeClass('filter-fixed');

          }
        });
      }
      position = scroll;
    });

    });
  }
}
